import dayjs from "dayjs"
import type { Table } from "exceljs"
import { child, onChildAdded, onValue, set } from "firebase/database"
import _ from 'lodash'
import ReceiptOrderClass from "~/class/ReceiptOrder"
import type { ReceiptOrderDynamodb } from "~/interface/ReceiptOrder"
import { useMobileV1Toast } from "~/composables/useMobileV1Toast"
import { JobMode } from "~/interface/Job"

export const usePosTerminalStore = defineStore("posTerminal", () => {


    // TERMINAL Cart
    function watchHandshakeFromTerminal() {
        const terminalHandshakeRef = useRealtimeDatabase().handshakeTerminalRef()
        onChildAdded(terminalHandshakeRef, (snapshot) => {
            const data = snapshot.val()
            if (data == 1) {
                set(snapshot.ref, 2)
                setTimeout(() => {
                    set(snapshot.ref, null)
                }, 2000)
            }
        })
    }

    function watchOrderFromTerminal() {
        const terminalOrderRef = useRealtimeDatabase().terminalJobRef()
        onChildAdded(terminalOrderRef, (snapshot) => {
            const data = snapshot.val()
            console.log(data)

            // The cashier is the SOLE authority for the JOB running number. The
            // terminal ships a JOB with no nickName (see pos.cart._buildJob); assign
            // it here BEFORE add(). Compute → assign → add() is await-free, so each
            // onChildAdded callback is atomic and, combined with the optimistic
            // insert in jobsStore.add(), reads an ever-incrementing fresh count.
            // No lock needed. (Legacy terminals that already set nickName keep it.)
            if (data && data.mode === JobMode.JOB && !data.nickName) {
                const n = usePosCartStore().getJobCurrentQueueNumber() + 1
                data.nickName = "Job #" + n
            }

            // Trust the CASHIER's clock, not the terminal's — each terminal's device
            // clock can be off. Stamp the PC receive time so the jobchain replays in
            // true arrival order regardless of any terminal's clock (computeJobchain
            // sorts by pcTimestamp||timestamp). Same pattern as pos.mobile-v1 and
            // pos.mobile-void-v1. Applies to every terminal order (all modes).
            if (data) {
                data.pcTimestamp = useServerTime().nowISO()
            }

            usePosJobsStore().add(data, true)

            // Announce the assigned number on a SEPARATE, additive node (does NOT
            // touch the legacy terminal_job / handshake contract). Keyed by the same
            // hash the terminal sent, so the terminal can look up its own number and
            // toast it. Legacy clients that don't read this node are unaffected.
            const hash = snapshot.key || (data?.hash != null ? String(data.hash) : '')
            if (hash) {
                const resultRef = child(useRealtimeDatabase().terminalJobResultRef(), hash)
                set(resultRef, {
                    nickName: data?.nickName || null,
                    jobId: data?.jobId || null,
                })
                setTimeout(() => { set(resultRef, null) }, 10000)
            }

            const alias = data?.nickName || data?.alias || data?.tableName || data?.table || 'Terminal'
            useMobileV1Toast().push({
                variant: 'success',
                text: `New order from terminal — ${alias}`,
                duration: 2000,
            })

            //settimeout remove this node
            setTimeout(() => {
                set(snapshot.ref, null)
            }, 2000)
        })
    }


    // TERMINAL Print Remote Request
    function sendPrintPreviewRequest(alias: string, receiptOrderDynamodb: ReceiptOrderDynamodb) {
        const printPreviewFromTerminalRef = useRealtimeDatabase().printPreviewFromTerminalRef()
        const _dbRef = child(printPreviewFromTerminalRef, alias)
        // Carry the terminal operator's name (receipt.User = the PIN'd employee on
        // THIS terminal) so the cashier prints the preview with the terminal's
        // cashier, not its own PIN. Old cashier builds ignore the object shape and
        // still read snapshot.val() — but those wrote a bare string, so the cashier
        // handler below accepts both. New shape: { alias, user }.
        set(_dbRef, { alias, user: receiptOrderDynamodb?.User || null })
    }
 
 

    function cleanAllRef() {
        // TODO: clean all ref
        const printPreviewFromTerminalRef = useRealtimeDatabase().printPreviewFromTerminalRef()
        set(printPreviewFromTerminalRef, null)
        
        const terminalHandshakeRef = useRealtimeDatabase().handshakeTerminalRef()
        set(terminalHandshakeRef, null)
        
        const terminalOrderRef = useRealtimeDatabase().terminalJobRef()
        set(terminalOrderRef, null)

        const terminalResultRef = useRealtimeDatabase().terminalJobResultRef()
        set(terminalResultRef, null)

    }



    function init() {
        cleanAllRef()
        watchHandshakeFromTerminal()
        watchOrderFromTerminal() 
    }

    return {
        init,
        sendPrintPreviewRequest,
    }
})
